import { Button, IconButton, Link, Stack, Typography } from "@mui/material";
import React from "react";
import {
  CustomDetailsList,
  CustomeDialog,
  DeleteModal,
  Loader,
  PageListLayout,
} from "../../../shared";
import { useNavigate, useParams } from "react-router-dom";
import UnpairDeviceDialog from "../components/UnpairDeviceDialog";
import { useDevices } from "../hooks";
import AddDeviceDialog from "../components/AddDeviceDialog";

export const DevicesDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    devices,
    onDelete,
    deviceDetails,
    handleOpenDialog,
    handlePairingStatus,
    handleAddDeviceDialogOpen,
    resetDeleteInfo,
    confirmDelete,
    deleteInfo,
    isEditable,
    isDeletable,
    isUnpairDevice,
  } = useDevices({
    deviceId: id,
    isList: false,
  });
  const breadcrumbs = [
    <Link
      underline="none"
      key="1"
      color="#1760D2"
      onClick={(e) => navigate("/devices")}
      sx={{ fontSize: "14px", fontWeight: 400 }}
    >
      Devices
    </Link>,
    <Typography
      key="2"
      color="inherit"
      sx={{ fontSize: "14px", fontWeight: 400 }}
    >
      {devices?.data?.name}
    </Typography>,
  ];

  const columns = [
    {
      title: "Device Name",
      accessor: (val) => (
        <Typography variant="subtitle2" fontWeight={500}>
          {val?.name}
        </Typography>
      ),
    },
    {
      title: "Device Code",
      accessor: (val) => (
        <Typography variant="subtitle2" fontWeight={500}>
          {val?.code}
        </Typography>
      ),
    },
    {
      title: "Store Name",
      accessor: (val) => (
        <Typography variant="subtitle2" fontWeight={500}>
          {val?.store_name}
        </Typography>
      ),
    },
    {
      title: "App Version",
      accessor: (val) => (
        <Typography variant="subtitle2" fontWeight={500}>
          {val?.version_id}
        </Typography>
      ),
    },
    {
      title: "Pairing Status",
      accessor: (val) => {
        return (
          <Stack direction="row" gap="8px">
            {val?.paired_status === 0 ? (
              <img src="/icons/ic_device_unpair.svg" alt="un pair" />
            ) : (
              <img src="/icons/ic_device_pair.svg" alt="pair" />
            )}

            {val?.paired_status ? "Paired" : "Unpaired"}
          </Stack>
        );
      },
    },
  ];
  return (
    <PageListLayout
      breadcrumbs={breadcrumbs}
      headerText={devices?.data?.name}
      rightContent={
        <Stack direction="row" alignSelf="center" gap={1}>
          {devices?.data?.paired_status === 0
            ? ""
            : isUnpairDevice && (
                <Button
                  sx="small"
                  variant="outlined"
                  onClick={(e) => handleOpenDialog(true, id)}
                  color="gray2"
                >
                  Unpair
                </Button>
              )}
          {isEditable && (
            <IconButton onClick={(e) => navigate(`/devices/edit/${id}`)}>
              <img
                alt="edit"
                src="/icons/ic_edit.png"
                style={{ cursor: "pointer" }}
              />
            </IconButton>
          )}
          {isDeletable && (
            <IconButton
              onClick={() => onDelete(id)}
              disabled={devices?.data?.paired_status}
              sx={{
                cursor: devices?.data?.paired_status
                  ? "not-allowed"
                  : "pointer",
                opacity: devices?.data?.paired_status ? 0.5 : 1,
              }}
            >
              <img
                alt="delete"
                src="/icons/ic_trash_sm.png"
                style={{
                  filter: devices?.data?.paired_status
                    ? "grayscale(100%)"
                    : "none",
                }}
              />
            </IconButton>
          )}
        </Stack>
      }
      sx={{
        p: "16px",
        pt: 0,
        backgroundColor: "background.paper",
        minHeight: "calc(100vh - 104px)",
      }}
    >
      {deviceDetails?.isLoading ? (
        <Loader />
      ) : (
        <CustomDetailsList
          columns={columns}
          data={devices?.data}
          title="Basic Details"
        />
      )}
      <CustomeDialog
        PaperProps={{
          sx: {
            minWidth: "500px",
          },
        }}
        closeIcon={false}
        open={devices?.open}
        title={
          <Stack
            direction="row"
            justifyContent="space-between"
            position="sticky"
            zIndex={999}
            bgcolor="background.paper"
            top={0}
          >
            <Stack direction="row" alignItems="center" ml={2}>
              <img src="/icons/ic_pair_dialog.svg" alt="pair icon" />
              <Typography
                fontWeight={500}
                variant="body1"
                padding="15px"
                fontSize={20}
              >
                Unpair this device?
              </Typography>
            </Stack>
          </Stack>
        }
        content={
          <UnpairDeviceDialog
            state={devices?.data}
            handleOpenDialog={handleOpenDialog}
            handlePairingStatus={handlePairingStatus}
            deviceDetails={deviceDetails}
          />
        }
      />
      <CustomeDialog
        PaperProps={{
          sx: {
            width: { sm: "460px", xs: "90%" },
          },
        }}
        closeIcon={false}
        open={devices?.openDialog}
        isHeader={false}
        content={
          <AddDeviceDialog
            state={devices?.data}
            handleAddDeviceDialogOpen={handleAddDeviceDialogOpen}
          />
        }
      />
      <DeleteModal
        open={deleteInfo?.show}
        handleClose={() => resetDeleteInfo()}
        onConfirm={() => confirmDelete()}
      />
    </PageListLayout>
  );
};
